import styled from 'styled-components'

export const StyledDiaryAlert = styled.div`
    font-size: 14px;
    letter-spacing: 0.44px;
`

export const StyledDiaryAlertTime = styled.div`
    font-size: 15px;
    color: ${({ theme }) => theme.greyishBrown};
    margin-right: 5px;
`
export const StyledDiaryAlertEvent = styled.div`
    color: ${({ theme, urgent }) => urgent ? theme.pastelRed : theme.brownGrey};
    margin-top: 5px;
    margin-bottom: 4px;
`
export const StyledDiaryAlertAdvice = styled.div`
    color: ${({ theme }) => theme.greyishBrown};
    font-weight: ${({ theme }) => theme.fontWeight.regular};
`
export const StyledDiaryAlertNotes = styled.div`
`
export const StyledDiaryAlertNote = styled.div`
`

export const StyledDiaryAlertWrapper = styled.div`
    display: flex;
    align-items: flex-end;
`